import { makeStateKey } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable } from 'rxjs';
import { CacheRef, resolverSSGFirst } from './ssg-first.utils';
import type { PaginaEntry } from '@core/interfaces/modyo';

const STATE_KEY = makeStateKey<PaginaEntry>('pagina-firma-digital');
const cache: CacheRef<PaginaEntry> = { valor: null };

export const resetCacheClienteFirmaDigital = (): void => {
  cache.valor = null;
};

export const firmaDigitalResolver: ResolveFn<PaginaEntry | null> = (): Observable<PaginaEntry | null> =>
  resolverSSGFirst({
    stateKey: STATE_KEY,
    cache,
    rutaSsg: 'firma-electronica',
    uidTipo: 'pagina',
    slug: 'pagina-firma-digital',
  });
